module.exports = __webpack_public_path__ + "assets/fonts/77701819-fc00-42d2-a545-05fe7939bf34.f0c295e5.eot";